module.exports = __webpack_public_path__ + "img/brandNewPart.6f94531d.webp";